(function () {
    'use strict';

    angular.module("imApp").factory("positionsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1109,
                    parameters: parms || {}
                });
            },
            listPositions: function (parms) {
                return $ihttp.post({
                    method: 1110,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
